import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

export const apiError = (message) => {
  return NotificationService.showNotification({
    title: '',
    notificationType: NOTIFICATION_TYPE_ERROR,
    content: <FormattedMessage {...message} />,
  });
};
